import AegisWrapper from '@src/slide/infrastructure/module/dependent/report/platform/aegis';
import type { EventLog } from '@tencent/aegis-web-sdk/lib/packages/core/src/interface';

type Action = 'start' | 'success' | 'fail';
type CommonReportData = {
    eventName: string;
    action: 'start';
} | {
    eventName: string;
    action: 'success' | 'fail';
    duration: number;
};

// TODO: 支持到不同平台的 (tam/007/tdw) adpater
type ReportData = Pick<EventLog, 'ext1' | 'ext2' | 'ext3'>;

interface Mark {
    startTime: number;
    reportData?: ReportData;
}

interface MarkMap {
    [businessName: string]: {
        [uniqueId: symbol]: Mark | undefined;
    } | undefined,
}

export interface IReportInstance {
    uniqueId: symbol;
    success: (reportData?: ReportData) => void;
    fail: (reportData?: ReportData) => void;
}

export class ReportUtils {
    private markMap: MarkMap = {};

    public start(businessName: string, reportData?: ReportData): IReportInstance {
        if (!this.markMap[businessName]) this.markMap[businessName] = {};
        const business = this.markMap[businessName]!;

        const uniqueId = Symbol(businessName);
        // 使用 performance.now() 记录开始时间戳
        business[uniqueId] = {
            startTime: performance.now(),
            reportData,
        };

        // 上报开始事件
        this.report({
            eventName: businessName,
            action: 'start',
        }, reportData);

        return {
            uniqueId,
            success: (reportData?: ReportData) => this.success(businessName, uniqueId, reportData),
            fail: (reportData?: ReportData) => this.fail(businessName, uniqueId, reportData),
        };
    }

    public success(businessName: string, uniqueId: symbol, reportData?: ReportData) {
        this.end('success', businessName, uniqueId, reportData);
    }

    public fail(businessName: string, uniqueId: symbol, reportData?: ReportData) {
        this.end('fail', businessName, uniqueId, reportData);
    }

    public end(action: Action, businessName: string, uniqueId: symbol, reportData?: ReportData) {
        const business = this.markMap[businessName];
        const mark = business?.[uniqueId];
        if (!mark) return;

        const endTime = performance.now();
        const duration = endTime - mark.startTime;
        // 上报结束事件和测量结果
        this.report({
            eventName: businessName,
            action,
            duration,
        }, {
            ...mark.reportData,
            ...reportData,
        });

        delete business[uniqueId];
    }

    private report(data: CommonReportData, reportData?: ReportData) {
        if (data.action === 'start') {
            AegisWrapper.getInstance().aegis.reportEvent({
                name: `${data.eventName}-${data.action}`,
                ...reportData,
            });
        } else {
            AegisWrapper.getInstance().aegis.reportEvent({
                name: `${data.eventName}-${data.action}`,
                ...reportData,
            });
            AegisWrapper.getInstance().aegis.reportT({
                name: data.eventName,
                duration: data.duration,
                ...reportData,
            });
        }
    }
}

export const reportUtils = new ReportUtils();
